import { render, staticRenderFns } from "./TextAreaWithLabel.vue?vue&type=template&id=4f80b179&"
import script from "./TextAreaWithLabel.vue?vue&type=script&lang=js&"
export * from "./TextAreaWithLabel.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaWithLabel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VIcon,VTextarea})
